import type React from 'react'
import { type IResourceComponentsProps, useResource } from '@refinedev/core'
import { Create, useForm } from '@refinedev/antd'
import { Form, Input } from 'antd'
import { checkPlatformUrl, PLATFORM_HOSTS } from '../../utils/platformUrl'

export const PlannerCreate: React.FC<IResourceComponentsProps> = () => {
  const { resource } = useResource()
  // resource name e.g. "it-ticketmaster" → platform "ticketmaster"
  const platform = resource?.name?.split('-').slice(1).join('-') ?? ''
  const expectedHosts = PLATFORM_HOSTS[platform]?.join(', ') ?? ''

  const { formProps, saveButtonProps /* queryResult */ } = useForm({
    errorNotification: (error: any) => {
      const status = error?.statusCode ?? error?.response?.status
      const apiError = error?.response?.data?.error
      if (status === 999 || apiError === 'Already Exists') {
        return {
          message: 'Evento già presente',
          description: 'Questo evento è già monitorato. Aprilo dalla lista per modificarlo.',
          type: 'error'
        }
      }
      return {
        message: 'Errore',
        description: apiError ?? error?.message ?? 'Impossibile aggiungere l\'evento',
        type: 'error'
      }
    }
  })

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout='vertical'>
        <Form.Item
          label='Event Url'
          name={['url']}
          extra={expectedHosts ? `Host validi per ${platform}: ${expectedHosts}` : undefined}
          rules={[
            {
              required: true
            },
            {
              validator: async (_, value) => {
                if (!value) return
                const err = checkPlatformUrl(value, platform)
                if (err) throw new Error(err)
              }
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label='Frequency between each scan in seconds '
          name={['frequency']}
          rules={[
            {
              required: false
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label='Old Less Than - Only show an alert if there is a variation and the old value is lower of this number'
          name={['oldLessThan']}
          rules={[
            {
              required: false
            }
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Create>
  )
}
